import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["render"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import RewardCenterInterface from '../../api/RewardCenterInterface';
import { setOfferHistory as _setOfferHistory, setActiveHistoryItem } from '../../state/actions/rewardCenter';
import { clearOnboarding } from '../../state/actions/currentOnboarding';
import { markOnboardingSeen as _markOnboardingSeen } from '../../state/actions/ftue';
import audio from '../../utils/audio';

var HistoryList = /*#__PURE__*/function (_Component) {
  _inherits(HistoryList, _Component);

  var _super = _createSuper(HistoryList);

  function HistoryList() {
    var _this;

    _classCallCheck(this, HistoryList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      hasData: false,
      isLoading: false
    };
    return _this;
  }

  _createClass(HistoryList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._getOfferHistory();
    }
  }, {
    key: "_getOfferHistory",
    value: function () {
      var _getOfferHistory2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var offerHistoryResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                audio.onClick();
                _context.prev = 1;
                this.setState({
                  isLoading: true
                });
                _context.next = 5;
                return RewardCenterInterface.getOfferHistory();

              case 5:
                offerHistoryResponse = _context.sent;
                offerHistoryResponse.forEach(function (historyItem, index, historyItems) {
                  historyItems[index].cat_icon = _this2.props.rewardCenterBaseUrl + historyItem.cat_icon;
                  var itemDate = moment(historyItem.date).format('DD/MM/YYYY');
                  historyItems[index].date = itemDate;
                });
                this.props.setOfferHistory(offerHistoryResponse);
                this.setState({
                  hasData: true
                });
                this.setState({
                  isLoading: false
                });
                _context.next = 14;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](1);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 12]]);
      }));

      function _getOfferHistory() {
        return _getOfferHistory2.apply(this, arguments);
      }

      return _getOfferHistory;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          render = _this$props.render,
          additionalProps = _objectWithoutProperties(_this$props, _excluded);

      return render(_objectSpread({
        hasData: this.state.hasData,
        onViewDetails: this.props.onViewDetails,
        isLoading: this.state.isLoading
      }, additionalProps));
    }
  }]);

  return HistoryList;
}(Component);

export default connect(function (state) {
  return {
    history: state.rewardCenter.api.history,
    rewardCenterBaseUrl: state.rewardCenter.rewardCenterBaseUrl,
    onboardingStep: state.currentOnboarding.currentStep
  };
}, function (dispatch) {
  return {
    setOfferHistory: function setOfferHistory(offerHistory) {
      dispatch(_setOfferHistory(offerHistory));
    },
    onViewDetails: function onViewDetails(offerPurchaseId) {
      return function (ev) {
        dispatch(setActiveHistoryItem(offerPurchaseId));
      };
    },
    markOnboardingSeen: function markOnboardingSeen(onboardingFlow) {
      dispatch(_markOnboardingSeen(onboardingFlow));
      dispatch(clearOnboarding());
    }
  };
})(HistoryList);